import * as Sentry from '@sentry/react';

/**
 * Inicializa Sentry para tracking de errores en producción.
 * Debe llamarse ANTES de montar React.
 */
export function initErrorTracking() {
  Sentry.init({
    dsn: "https://4db4c6e6da2d2cf80863dbb825971d07@o4511059615612928.ingest.de.sentry.io/4511270829293648",
    environment: window.location.hostname === 'localhost' ? 'development' : 'production',
    enabled: window.location.hostname !== 'localhost',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Rendimiento: capturar 20% de transacciones en producción
    tracesSampleRate: 0.2,
    // Replay: capturar 10% de sesiones normales, 100% de sesiones con error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

}

/**
 * Reporta un error a Sentry con contexto adicional.
 * Reemplaza console.error() en los catch blocks.
 */
export function captureError(error: unknown, context?: Record<string, unknown>) {
  console.error(error);
  if (context) {
    Sentry.withScope((scope) => {
      scope.setExtras(context);
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
}

/**
 * Asocia el usuario actual a los eventos de Sentry.
 * Llamar cuando el usuario hace login.
 */
export function setUserContext(userId: string, email?: string) {
  Sentry.setUser({ id: userId, email: email || undefined });
}

/**
 * Limpia el contexto de usuario.
 * Llamar cuando el usuario hace logout.
 */
export function clearUserContext() {
  Sentry.setUser(null);
}
